<!-- 开放许可专区 -->
<template>
  <div class="development">
    <div class="banner">
      <div class="content">
        <div class="search">
          <input
            type="text"
            v-model="keyword"
            placeholder="请输入关键词"
            @keyup.enter="handleSearch"
          />
          <button @click="handleSearch">
            <img src="../assets/search_icon.png" alt="" />搜索
          </button>
        </div>
        <div class="query">
          <div class="categories">
            <!-- 动态渲染分类 -->
            <div
              class="category-group"
              v-for="(category, index) in categories"
              :key="index"
            >
              <h3>{{ category.title }}</h3>
              <ul>
                <li
                  v-for="(item, i) in category.items"
                  :key="i"
                  :class="{
                    active: activeItems[index] === i,
                    'default-active':
                      i === 0 && !activeItems.hasOwnProperty(index),
                  }"
                  @click="selectItem(index, i)"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main">
      <div class="content">
        <div class="main_box">
          <div class="header">
            <div class="sort">
              <el-dropdown trigger="click" @command="handleSortChange">
                <span class="el-dropdown-link">
                  {{ currentSort
                  }}<img src="../assets/bottomArrow.png" alt="" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in sortOptions"
                    :key="item"
                    :command="item"
                  >
                    <!-- @click.native="currentSort = item" -->
                    {{ item }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="result">
              <p>搜索结果：</p>
              共有
              <p>{{ total }}</p>
              个结果
            </div>
            <div class="reset" @click="handleReset">
              <i class="el-icon-refresh-right"></i>
              <p>重置搜索</p>
            </div>
          </div>
          <div class="table" v-loading="loading">
            <table>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>专利申请号</th>
                  <th>专利名称</th>
                  <th>产业分类</th>
                  <th>案源方分类</th>
                  <th>专利类型</th>
                  <th>专利权人</th>
                  <th>许可费用</th>
                  <th>许可支付类型</th>
                  <th>单次许可期限</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in tableData"
                  :key="item.id"
                  @click="getOpenDetails(item)"
                  style="cursor: pointer"
                >
                  <td>{{ (page - 1) * pageSize + index + 1 }}</td>
                  <td>{{ item.application_number }}</td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.industrial_classification || "/" }}</td>
                  <td>{{ item.classification_of_case_sources }}</td>
                  <td>{{ item.patent_type }}</td>
                  <td>{{ item.patentee }}</td>
                  <td>{{ item.license_fee }}</td>
                  <td>
                    {{ item.license_payment_type }}
                  </td>
                  <td>{{ item.license_term }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="paging">
            <!-- <div class="pagingLeft">
                        <span>每页</span>
                        <el-select v-model="pageSize" placeholder="请选择" @change="handleSizeChange">
                            <el-option v-for="item in pageSizesOptions" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                        <span>条</span>
                    </div> -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOpenLicense, getParams } from "../api/userApi";
export default {
  data() {
    return {
      page: 1,
      pageSize: 10, // 默认每页显示10条
      total: 0, // 总数据量
      loading: false,
      pageSizesOptions: [10, 20, 30, 40], // 可供选择的每页显示条数
      currentSort: "按人气排序",
      sortOptions: ["按人气排序", "按发布时间排序"],
      sortField: "views", // 默认按人气排序
      sortType: "desc", // 默认降序
      isDescending: true, //标记当前是否是降序
      activeItems: {},
      keyword: "",
      categories: [
        {
          title: "产业分类:",
          items: ["全部"],
          key: "industrial_classification",
          paramKey: "industrial_classification",
          originalItems: [],
        },
        {
          title: "案源分类:",
          items: ["全部"],
          key: "classification_of_case_sources",
          paramKey: "classification_of_case_sources",
          originalItems: [],
        },
        {
          title: "专利类型:",
          items: ["全部"],
          key: "patent_type",
          paramKey: "patent_type",
          originalItems: [],
        },
        {
          title: "许可支付类型:",
          items: ["全部"],
          key: "license_payment_type",
          paramKey: "license_payment_type",
          originalItems: [],
        },
      ],
      tableData: [],
    };
  },
  async created() {
    // 获取用户信息
    await this.getParams();
    this.getOpenLicenseData();
  },
  methods: {
    async getParams() {
      try {
        const response = await getParams();
        console.log(response, "response");
        if (response.code === 1) {
          this.categories.forEach((category) => {
            const apiData = response.data[category.key];
            if (apiData && apiData.data) {
              category.originalItems = apiData.data;
              category.items = [
                "全部",
                ...apiData.data.map((item) => item.title),
              ];
            }
          });
        }
      } catch (error) {
        console.error("获取接口失败", error);
      }
    },
    async getOpenLicenseData() {
      this.loading = true;
      try {
        // 构建查询参数
        const params = {
          page: this.page,
          limit: this.pageSize,
          // keyword: this.keyword || undefined,
          sort_field: this.sortField,
          sort_type: this.sortType,
        };
        // 添加搜索关键词
        if (this.keyword) {
          params.keyword = this.keyword;
        }

        // 添加分类筛选条件
        this.categories.forEach((category, index) => {
          const selectedIndex = this.activeItems[index];
          if (selectedIndex > 0) {
            const selectedItem = category.originalItems[selectedIndex - 1];
            if (selectedItem) {
              params[category.paramKey] = selectedItem.id; // 根据API文档，直接传递分类名称
            }
          }
        });
        const response = await getOpenLicense(params);
        if (response.code === 1) {
          this.tableData = response.data;
          this.total = response.count;
        }
      } catch (error) {
        console.error("获取开放许可数据失败", error);
      } finally {
        this.loading = false;
      }
    },
    // 搜索方法
    handleSearch() {
      this.page = 1; // 搜索时重置到第一页
      this.getOpenLicenseData();
    },
    // 分类筛选
    selectItem(categoryIndex, itemIndex) {
      this.$set(this.activeItems, categoryIndex, itemIndex);
      this.page = 1; // 筛选时重置到第一页
      this.getOpenLicenseData();
    },
    // 排序变化
    handleSortChange(sortOption) {
      // 如果是切换不同排序字段，重置为降序
      if (this.currentSort !== sortOption) {
        this.isDescending = true;
        this.sortType = "desc";
      } else {
        // 如果是同一排序字段，切换排序方向
        this.isDescending = !this.isDescending;
        this.sortType = this.isDescending ? "desc" : "asc";
      }

      this.currentSort = sortOption;
      this.sortField = sortOption === "按人气排序" ? "views" : "create_time";

      this.page = 1;
      this.getOpenLicenseData();
    },
    // 重置搜索
    handleReset() {
      this.keyword = "";
      this.activeItems = {};
      this.page = 1;
      this.currentSort = "按人气排序";
      this.sortField = "views";
      this.sortType = "desc";
      this.getOpenLicenseData();
    },
    // 查看详情
    getOpenDetails(item) {
      this.$router.push({
        path: "/openDetails",
        query: { id: item.id },
      });
    },
    // 分页变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.getOpenLicenseData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getOpenLicenseData();
    },
  },
};
</script>

<style scoped lang="less">
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
  //   position: absolute;
}
::v-deep .el-dropdown-menu {
  left: 287px !important;
}
.banner {
  //   position: relative;
  background: url(../assets/banner2.png) no-repeat center/cover;
  width: 100%;
  height: 318px;
  .content {
    width: 100%;
    max-width: 87.5rem;
    margin: 0 auto;
    position: relative;
    .query {
      position: absolute;
      width: 100%;
      //   height: 294px;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
      left: 0;
      bottom: -342px;
      padding: 37px 35px;
      box-sizing: border-box;
      .categories {
        display: flex;
        flex-direction: column;
        .category-group {
          //   border-bottom: 1px dashed #d8d8d8;
          background-image: linear-gradient(
            to right,
            #d8d8d8 50%,
            transparent 50%
          );
          background-size: 20px 1px; /* 控制虚线间距：10px 为总长度，50% 透明，50% 实色 */
          background-repeat: repeat-x;
          background-position: bottom; /* 底部边框 */
          display: flex;
          //   padding-left: 20px;
          padding: 20px 0 5px 20px;
          box-sizing: border-box;
          h3 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #121212;
            width: 8%;
            text-align: left;
          }
          ul {
            width: 92%;
            display: flex;
            flex-wrap: wrap;
            li {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #121212;
              margin-right: 10px;
              margin-bottom: 4px;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 3px 10px;
              &.active,
              &.default-active {
                background: #175dc2;
                color: #fff;
                padding: 3px 10px;
                box-sizing: border-box;
              }
            }
          }
        }
        .category-group:last-child {
          background-size: 20px 0px;
        }
        .category-group:first-child {
          padding-top: 0;
        }
      }
    }
  }
  .search {
    padding-top: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      width: 638px;
      height: 50px;
      background: #ffffff;
      border-radius: 9px 0px 0px 9px;
      border: none; /* 移除边框 */
      outline: none;
      padding-left: 25px;
    }
    input::placeholder {
      //   padding-left: 25px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #a9a9a9;
      font-style: normal;
    }
    input:focus {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #121212;
      font-style: normal;
    }
    button {
      cursor: pointer;
      border: none;
      outline: none;
      width: 96px;
      height: 50px;
      background: #c5e1ff;
      border-radius: 0px 9px 9px 0px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #175dc2;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-right: 3px;
      }
    }
  }
}
.main {
  background: #f5f5f5;
  padding-top: 155px;
  padding-bottom: 45px;
  width: 100%;
  .main_box {
    width: 100%;
    // height: 1017px;
    background: #fff;
    border-radius: 10px;
    padding: 15px 40px 35px 40px;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .sort {
        width: 124px;
        height: 39px;
        background: #ffffff;
        border: 1px solid #d3d3d3;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          margin-left: 10px;
        }
        ::v-deep .el-popper ul {
          left: 299px !important;
        }
      }
      .result {
        display: flex;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: rgba(18, 18, 18, 1);
        p {
          color: #175dc2;
        }
      }
      .reset {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 114px;
        height: 39px;
        background: #ffffff;
        border: 1px solid #d3d3d3;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #121212;
        line-height: 20px;
        cursor: pointer;
        i {
          margin-right: 10px;
          line-height: 20px;
        }
      }
    }
    .table {
      //   width: 100%;
      table {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse; /* 合并单元格边框 */
        border-spacing: 0; /* 移除单元格之间的间距 */
        margin: 15px 0 35px 0;
        th,
        td {
          /* 强制不换行 */
          white-space: nowrap;
          /* 内容超出容器隐藏 */
          overflow: hidden;
          /* 使用省略号表示被隐藏的内容 */
          text-overflow: ellipsis;
          /* 设置最大宽度或固定宽度 */
          width: 10%; /* 根据实际情况调整 */
          /* 确保内容不会自动扩展td的宽度 */
          // display: inline-block;
          /* 可选：设定一个固定高度，如果适用 */
          height: 50px; /* 根据实际情况调整 */
          line-height: 50px;
        }
        thead {
          border-radius: 5px;
          background: #175dc2;

          tr {
            height: 50px;
            th {
              // width: 10%;
              font-family: PingFang SC, PingFang SC;

              font-weight: 600;
              font-size: 14px;
              color: #ffffff;
            }
          }
        }
        tbody {
          tr:nth-child(odd) {
          }
          tr:nth-child(even) {
            background: #f2f4fe;
            border-radius: 5px;
          }
          tr {
            td {
              // height: 50px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #121212;
              // white-space: nowrap; /* 禁止文字换行 */
              // overflow: hidden; /* 超出部分隐藏 */
              // text-overflow: ellipsis;
            }
          }
        }
      }
    }
    .paging {
      display: flex;
      justify-content: flex-end;
      padding-right: 45px;
    }
  }
}
</style>
